import { render } from "./IsoLogs.vue?vue&type=template&id=566a420e&scoped=true"
import script from "./IsoLogs.vue?vue&type=script&lang=js"
export * from "./IsoLogs.vue?vue&type=script&lang=js"

import "./IsoLogs.vue?vue&type=style&index=0&id=566a420e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\AbdullahiIsmail\\OneDrive - SWWIPE FINACIAL SERVICES\\Documents\\Automation-tool\\auto-portalV2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-566a420e"]])

export default __exports__